import BaseStore from './BaseStore';
import { observable, runInAction } from 'mobx';
import { get, getUrlParam } from '../utils';
import { toast, alert } from '../components';
import store from '../store';

export default class UserStore extends BaseStore {

    @observable public userInfo: any = {};
    @observable public userInfoObj: any = {}; // 用户信息
    @observable public addId: any = 0; // 收货地址
    @observable public addressData: any = {}; // 默认地址
    @observable public cartNum: any = 0; // 购物车
    @observable public partnerId: any = 'wxs9FQ9mBfYfelaugNYZ-A'; // 合伙人id
    @observable public addressObj: any = {}; // 地址信息
    @observable public shopInfo: any = {}; // 店铺信息
    @observable public defaultAddress: any = {}; // 地址信息
    @observable public shopCode: any = 0; // 店主店铺code

    setPartnerId() {
        let partnerId = getUrlParam('partnerId') || window.sessionStorage.getItem('__partnerId') || '';
        if (partnerId.length > 0 && partnerId.lastIndexOf('/') === partnerId.length - 1) {
            partnerId = partnerId.substr(0, partnerId.length - 1);
        }
        this.partnerId = partnerId || 'wxs9FQ9mBfYfelaugNYZ-A';
        if (partnerId) {
            window.sessionStorage.setItem('__partnerId', partnerId);
        }
        if (store.status.gameApp) {
            this.checkUserIdentity();
        }
        if (window.location.href.indexOf('?partnerId=') <= -1) {
            let urlArr: any[] = location.href.split('#');
            window.history.replaceState(null, document.title, `${urlArr[0]}?partnerId=${this.partnerId}#${urlArr[1] ? urlArr[1] : '!/'}`);
        }
    }

    // 请求接口判断用户是不是VIP或者店主
    checkUserIdentity() {
        get('user/v1/info').then((res) => {
            if (res.errCode === 200) {
                if (res.data.type === 1 && res.data.level === 1) {// 身份是访客
                    store.status.isVipOrShopkeeper = false;
                } else {
                    store.status.isVipOrShopkeeper = true;
                }
            } else {
                toast(res.errDesc);
            }
        });
    }

    fetch() {
        if (store.status.gameApp) {
            return get('user/v1/info').then((d) => {
                let data = d.data;
                if (d.errCode === 200) {
                    runInAction(() => {
                        this.userInfoObj = data;
                        Object.assign(this.userInfo, data);
                    });
                } else {
                    alert(d.errMsg, [
                        '取消',
                        {
                            text: '确认', onClick: () => {
                                location.reload();
                            }
                        }
                    ]);
                }
            });
        } else {
            // let code = window.location.search ? window.location.search.split("=")[1].split("&")[0] : ""
            return get('user/weixin/v1/info').then((d) => {
                let data = d.data;
                if (d.errCode == 200) {
                    runInAction(() => {
                        this.userInfoObj = data;
                        Object.assign(this.userInfo, data);
                    });
                } else {
                    alert('获取信息失败请重新登陆', [
                        '取消',
                        {
                            text: '确认', onClick: () => {
                                // location.reload();
                                let myHash = window.location.origin
                                // let myHash = "https://pub.gjyymall.com"

                                // let url: any = defaultOption.appUrl;
                                let url: any = `${window.location.origin}/api/pub/user/weixin/v1/login`
                                let appId = store.status.gameId ? store.status.gameId : 'wx2221b616ef2ea5f1'
                                let localtionwxUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=' + encodeURIComponent(myHash) + '&connect_redirect=0#wechat_redirect'; // 微信地址
                                location.replace(localtionwxUrl);

                                return new Promise((resolve) => {
                                    return resolve(false);
                                }).then((resolve) => {
                                    return false;
                                });
                            }
                        }
                    ]);
                }
            });
        }
    }

    fetch2() {
        let code = 'kjsdghf';
        return get('user/weixin/v1/dev/login', {
            code: code,
            state: 'STATE'
        }).then((d) => {
            if (d.errCode === 200) {
                runInAction(() => {
                    Object.assign(this.userInfo, d.data);
                });
            } else {
                // alert('获取信息失败请重新登陆', [
                //     '取消',
                //     {
                //         text: '确认', onClick: () => {
                //             location.reload();
                //         }
                //     }
                // ]);
            }
        });
    }

    add() {
        return get('address/v1/default').then((d) => {
            if (d.data) {
                !this.addId && (this.addId = d.data.addressId);
                this.addressData = d.data;
            }
        }).catch((data) => {
            toast(data.message);
        });
    }

    shopNum() {
        return get('newproduct/carts/v1/counts').then((d) => {
            if (d.data) {
                this.cartNum = d.data;
                return d.data
            }
        }).catch((data) => {
            toast(data.message);
        });
    }

    getShopName() {
        let that = this;
        if (this.partnerId) {
            return get('user/store/v1/info', {
                partnerId: that.partnerId
            }).then((d) => {
                this.shopCode = d.errCode;
                if (this.shopCode == 1100) {
                    toast('此店铺不存在');
                } else {
                    if (d.data) {
                        this.shopInfo = d.data;
                    }
                }
            }).catch((data) => {

            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/UserStore.ts